import { Api } from "metabase/api";
import { invalidateTags, provideModeratedItemTags } from "metabase/api/tags";
import type { ModerationReview, VerifyItemRequest } from "metabase-types/api";

export const contentVerificationApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    createModerationReview: builder.mutation<
      ModerationReview,
      VerifyItemRequest
    >({
      query: (body) => ({
        method: "POST",
        url: "/api/moderation-review",
        body,
      }),
      // The item's list tag refreshes search results, collection items and
      // recents, which all show the verified badge.
      invalidatesTags: (_review, error, request) =>
        invalidateTags(
          error,
          provideModeratedItemTags(
            request.moderated_item_type,
            request.moderated_item_id,
          ),
        ),
    }),
  }),
});

export const { useCreateModerationReviewMutation } = contentVerificationApi;
